import { createClient } from '@supabase/supabase-js';

// Supabase configuration
// These will be automatically populated by Vercel when you connect Supabase
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
